import { Controller } from "@hotwired/stimulus"
import { MapConfig } from "./map/map_config.js";
import { LocateControl } from "leaflet.locatecontrol";

export default class extends Controller {
  static targets = ["latitude", "longitude", "geolocation"]

  connect() {    
    setTimeout(() => {
      let self = this;

      // init markers
      let markers = new L.FeatureGroup();

      let center = (this.latitudeTarget.value && this.longitudeTarget.value) ? 
        [this.latitudeTarget.value, this.longitudeTarget.value] : [45.332075, 14.808559];
      markers.addLayer(L.marker(center));

      const map = L.map(this.geolocationTarget).setView(center, 12);
  
      // Add OSM tile layer for preview
      const osmConfig = MapConfig.getOSMTileLayerOptions();
      L.tileLayer(osmConfig.url, osmConfig.options).addTo(map);

      // Add scale control
      L.control.scale().addTo(map);

      // show the locate button on the upper right corner
      L.Control.GeoLocator = LocateControl.extend({
        _drawMarker: function () {
          self.latitudeTarget.value = this._event.latlng.lat;
          self.longitudeTarget.value = this._event.latlng.lng;

          LocateControl.prototype._drawMarker.call(this);
        }
      });
      new L.Control.GeoLocator({drawCircle: false}).addTo(map);

      map.addLayer(markers);

      // listen for a click
      map.on('click', function (e) {
        // remove marker layer to clean the map
        if (markers != undefined) {
          map.removeLayer(markers);
          markers = new L.FeatureGroup();
        }

        // set lat and lng into form fields
        self.latitudeTarget.value = e.latlng.lat;
        self.longitudeTarget.value = e.latlng.lng;

        // show marker
        markers.addLayer(L.marker(e.latlng));
        map.addLayer(markers);
      });
    }, 300);
  }
}
